import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import { db } from "../firebase";
import useUpdateProduct from "../utils/useUpdateProduct";
import useAddProduct from "../utils/useAddProduct";
import useDeleteProduct from "../utils/useDeleteProduct";

const Admin = () => {
  const [products, setProducts] = useState([]);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [popup, setPopup] = useState(null);

  const name = useRef(null);
  const price = useRef(null);
  const discountedPrice = useRef(null);
  const imgUrl1 = useRef(null);
  const imgUrl2 = useRef(null);
  const imgUrl3 = useRef(null);
  const imgUrl4 = useRef(null);
  const apikey = useRef(null);

  const updateProduct = useUpdateProduct;
  const addProduct = useAddProduct;
  const deleteProduct = useDeleteProduct;

  const usersCollectionRef = collection(db, "products");

  const handleAdd = () => {
    if (process.env.REACT_APP_API_KEY === apikey.current.value) {
      addProduct(
        name.current.value,
        price.current.value,
        discountedPrice.current.value,
        [
          imgUrl1.current.value,
          imgUrl2.current.value,
          imgUrl3.current.value,
          imgUrl4.current.value,
        ]
      );
    } else {
      alert("Please Enter Valid API KEY");
    }
    setPopup(null);
  };

  const handleEdit = () => {
    if (process.env.REACT_APP_API_KEY === apikey.current.value) {
      updateProduct(
        currentProduct.id,
        name.current.value,
        price.current.value,
        discountedPrice.current.value,
        [
          imgUrl1.current.value,
          imgUrl2.current.value,
          imgUrl3.current.value,
          imgUrl4.current.value,
        ]
      );
    } else {
      alert("Please Enter Valid API KEY");
    }
    setPopup(null);
  };

  const handleDelete = (id) => {
    if (process.env.REACT_APP_API_KEY === apikey.current.value) {
      deleteProduct(id);
    } else {
      alert("Please Enter Valid API KEY");
    }
  };

  const getProducts = async () => {
    try {
      const data = await getDocs(usersCollectionRef);
      const productsData = data.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setProducts(productsData);
    } catch (error) {}
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className="container mx-auto p-4">
      {popup && (
        <>
          <div
            onClick={() => {
              setPopup(null);
            }}
            className="absolute top-0 bottom-0 right-0 left-0 bg-[#2f2f2f85]"
          ></div>
          <form
            onSubmit={(e) => e.preventDefault()}
            className="grid grid-cols-1 gap-4 fixed w-[400px] bg-white p-8 rounded-md top-1/2 -translate-x-1/2 left-1/2 -translate-y-1/2 shadow-2xl max-w-[90vw]"
          >
            <p
              onClick={() => {
                setPopup(null);
              }}
              className="cursor-pointer fixed -top-2 -right-2 rotate-45 text-5xl"
            >
              +
            </p>

            {popup === "delete" ? (
              <>
                <input
                  required
                  ref={apikey}
                  type="password"
                  placeholder="API KEY"
                  className="border p-2"
                />
                <button
                  onClick={() => {
                    handleDelete(currentProduct.id);
                    setPopup(null);
                  }}
                  className="bg-red-500 text-white py-2 px-4 rounded"
                >
                  Delete Product
                </button>
              </>
            ) : (
              <>
                <input
                  required
                  ref={name}
                  type="text"
                  name="name"
                  placeholder="Product Name"
                  className="border p-2"
                />
                <input
                  required
                  ref={price}
                  type="number"
                  name="price"
                  placeholder="Price"
                  className="border p-2"
                />
                <input
                  required
                  ref={discountedPrice}
                  type="number"
                  name="discountedPrice"
                  placeholder="Discounted Price"
                  className="border p-2"
                />
                <input
                  required
                  ref={imgUrl1}
                  type="text"
                  placeholder="Image URL 1"
                  className="border p-2"
                />
                <input
                  required
                  ref={imgUrl2}
                  type="text"
                  placeholder="Image URL 2"
                  className="border p-2"
                />
                <input
                  required
                  ref={imgUrl3}
                  type="text"
                  placeholder="Image URL 3"
                  className="border p-2"
                />
                <input
                  required
                  ref={imgUrl4}
                  type="text"
                  placeholder="Image URL 4"
                  className="border p-2"
                />
                <input
                  required
                  ref={apikey}
                  type="password"
                  placeholder="API KEY"
                  className="border p-2"
                />
                {popup === "edit" ? (
                  <button
                    onClick={handleEdit}
                    className="bg-blue-500 text-white py-2 px-4 rounded"
                  >
                    Edit Product
                  </button>
                ) : popup === "add" ? (
                  <button
                    onClick={handleAdd}
                    className="bg-green-500 text-white py-2 px-4 rounded"
                  >
                    Add Product
                  </button>
                ) : null}
              </>
            )}
          </form>
        </>
      )}
      <h1 className="text-2xl font-bold mb-4">Admin Panel</h1>

      <div className="mb-8">
        {/* <h2 className="text-xl font-semibold mb-2">Add</h2> */}
        <div className="grid grid-cols-1 gap-4">
          <button
            onClick={() => setPopup("add")}
            className="bg-blue-500 text-white py-2 px-4 rounded"
          >
            Add New Product
          </button>
        </div>
      </div>

      <h2 className="text-xl font-semibold mb-2">Product List</h2>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="border p-2">Name</th>
            <th className="border p-2">Price</th>
            <th className="border p-2">Discounted Price</th>
            <th className="border p-2">Images</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr key={index}>
              <td className="border p-2">{product.name}</td>
              <td className="border p-2">₹{product.price}</td>
              <td className="border p-2">₹{product.discountedPrice}</td>
              <td className="border p-2 flex  flex-wrap gap-2">
                {product.images.map((img, imgIndex) => (
                  <img
                    key={imgIndex}
                    src={img}
                    alt={`Product ${imgIndex + 1}`}
                    className="w-16 h-16 object-cover aspect-square rounded-md"
                  />
                ))}
              </td>
              <td className="border p-2 ">
                <button
                  onClick={() => {
                    setCurrentProduct(product);
                    setPopup("edit");
                  }}
                  className="bg-yellow-500 text-white py-1 px-2 rounded m-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => {
                    setCurrentProduct(product);
                    setPopup("delete");
                  }}
                  className="bg-red-500 text-white py-1 px-2 rounded m"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Admin;
